/**
 * 模块: BrandNetworkGraph主组件
 * 职责: 品牌竞争网络图谱主入口
 * 限制: 文件<280行, 函数<30行
 */

import React, { useEffect, useRef } from 'react';
import { Card } from 'antd';
import { BrandNetworkGraphProps } from './types';
import { renderGraph } from './render';
import Legend from './Legend';

const BrandNetworkGraph: React.FC<BrandNetworkGraphProps> = ({ nodes, edges, ownBrand }) => {
  const svgRef = useRef<SVGSVGElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!svgRef.current || !containerRef.current || nodes.length === 0) return;

    // 使用容器的实际尺寸
    const containerRect = containerRef.current.getBoundingClientRect();
    const width = containerRect.width;
    const height = containerRect.height;

    // 渲染图表
    const simulation = renderGraph(svgRef.current, nodes, edges, width, height);

    return () => {
      simulation.stop();
    };
  }, [nodes, edges, ownBrand]);

  return (
    <Card 
      title="品牌竞争网络图谱" 
      extra="节点大小和颜色表示品牌市场影响力，连线粗细表示竞争强度"
    >
      <div 
        ref={containerRef}
        style={{ 
          width: '100%', 
          height: '1000px',  // 增加高度：800px -> 1000px
          backgroundColor: '#fafafa',
          borderRadius: '8px',
          position: 'relative'
        }}
      >
        <svg ref={svgRef} style={{ width: '100%', height: '100%', display: 'block' }} />
      </div>
      <Legend />
    </Card>
  );
};

export default BrandNetworkGraph;

